<div class="c-header-gradient">
	<img class="header-gradient_primary"
		fetchpriority="high"
		width="1440"
		height="684"
		src="{{@shared.assetsHost}}/img/about/about-gradient.jpg" />

	<div class="header-gradient_secondary"></div>

	{{#if showMap}}
		<div class="header-gradient_map"></div>
	{{/if}}
</div>
